import { motion } from 'framer-motion';

export function TermsOfService() {
  return (
    <div className="min-h-screen pt-32 pb-16 bg-brand-white">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
        >
          <h1 className="text-4xl font-extrabold text-secondary-900 mb-8">Terms of Service</h1>
          
          <div className="prose prose-blue max-w-none text-secondary-700">
            <p className="mb-4">Last Updated: {new Date().toLocaleDateString()}</p>
            
            <h2 className="text-2xl font-bold text-secondary-900 mt-8 mb-4">1. Acceptance of Terms</h2>
            <p className="mb-4">
              By accessing and using the Wote InterCity website and mobile applications, you accept and agree to be bound by the terms and provision of this agreement.
            </p>

            <h2 className="text-2xl font-bold text-secondary-900 mt-8 mb-4">2. Booking and Payments</h2>
            <p className="mb-4">
              All bookings are subject to availability. Payment must be made in full at the time of booking. We accept various forms of payment as displayed on our checkout page. Fares are subject to change without prior notice.
            </p>

            <h2 className="text-2xl font-bold text-secondary-900 mt-8 mb-4">3. Cancellations and Refunds</h2>
            <p className="mb-4">
              Tickets may be cancelled up to 24 hours before the scheduled departure time for a partial refund, subject to cancellation fees. Tickets cancelled within 24 hours of departure are strictly non-refundable.
            </p>

            <h2 className="text-2xl font-bold text-secondary-900 mt-8 mb-4">4. Passenger Responsibilities</h2>
            <p className="mb-4">
              Passengers must arrive at the departure terminal at least 30 minutes prior to the scheduled departure time. Wote InterCity reserves the right to refuse carriage to any person whose conduct is deemed unsafe or disruptive.
            </p>

            <h2 className="text-2xl font-bold text-secondary-900 mt-8 mb-4">5. Limitation of Liability</h2>
            <p className="mb-4">
              Wote InterCity shall not be liable for any indirect, incidental, special, consequential or punitive damages resulting from your use of or inability to use the service.
            </p>
          </div>
        </motion.div>
      </div>
    </div>
  );
}
